import script from "./base-list.vue?vue&type=script&setup=true&lang=ts&generic=Items%20extends%20any%5B%5D%20%3D%20%5B%5D"
export * from "./base-list.vue?vue&type=script&setup=true&lang=ts&generic=Items%20extends%20any%5B%5D%20%3D%20%5B%5D"

const cssModules = {}
import style0 from "./base-list.vue?vue&type=style&index=0&id=6455cb2a&module=true&lang=css"
cssModules["$style"] = style0
/* custom blocks */
import block0 from "./base-list.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__